import React from "react";
import iosInstallIcon from 'images/appStoreBlack.svg'
import frame1 from 'images/Frame 1-4.png'
import frame2 from 'images/Frame 2-2.png'
import frame3 from 'images/Frame 3-2.png'
import frame4 from 'images/Frame 4-2.png'
import frame5 from 'images/Frame 5-2.png'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import 'components/about/about.css';

class About extends React.Component {

    render() {

        return (
            <div className="AboutContent">
                <h4 class="about-header">NOW PRESENTING</h4>
                <h3>Shank Scores</h3>
                <p>Make every round matter with Shank - the golf app that provides insights into your game from your scorecard alone.</p>

                <a title="Go to Shank Scores on the iOS app store" href="https://apps.apple.com/us/app/shank-scores/id1608112527">
                    <img alt="Icon for installing on the app store" src={iosInstallIcon} />
                </a>

                <Carousel
                    additionalTransfrom={0}
                    arrows
                    autoPlaySpeed={3000}
                    centerMode={false}
                    className="screenshot-gallery"
                    containerClass=""
                    draggable
                    focusOnSelect={false}
                    infinite={false}
                    keyBoardControl
                    minimumTouchDrag={80}
                    renderButtonGroupOutside={false}
                    renderDotsOutside={true}
                    responsive={{
                        desktop: {
                            breakpoint: { max: 3000, min: 1024 },
                            items: 5,
                            slidesToSlide: 1
                        },
                        tablet: {
                            breakpoint: { max: 1024, min: 464 },
                            items: 3,
                            slidesToSlide: 1
                        },
                        mobile: {
                            breakpoint: { max: 464, min: 0 },
                            items: 1,
                            slidesToSlide: 1
                        }
                    }}
                    showDots
                    swipeable
                >
                    <img alt="Shank Scores screenshot 1" className="screenshot" src={frame1} />
                    <img alt="Shank Scores screenshot 5" className="screenshot" src={frame5} />
                    <img alt="Shank Scores screenshot 2" className="screenshot" src={frame2} />
                    <img alt="Shank Scores screenshot 3" className="screenshot" src={frame3} />
                    <img alt="Shank Scores screenshot 4" className="screenshot" src={frame4} />
                </Carousel>

                <div className="dev-notes">
                    <h4>Latest Updates</h4>
                    <div className="note">
                        <h5>Scorecard Stories <span className="note-date">May 30, 2025</span></h5>
                        <p>After posting a scorecard, you now have the option to tell the story behind your scores!</p>
                    </div>
                    <div className="note">
                        <h5>Performance & UX Improvements <span className="note-date">May 16, 2025</span></h5>
                        <p>Greatly reduced player page load time, improvements to course and tee selector in create scorecard screen as well as general UX improvements throughout the app.</p>
                    </div>
                    <div className="note">
                        <h5>Matchups <span className="note-date">May 1, 2025</span></h5>
                        <p>Introducing head-to-head matchups! Shank+ members are now able to track their historical results against each opponent they've played.</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default About;
